import { RegisteredComponent } from "@builder.io/sdk-react";
import { textualFormConfig } from "./textualFormConfigs";
import { generalFormConfig } from "./generalFormConfig";

const DiallingCodeFields: RegisteredComponent["inputs"] = [
  {
    name: "label",
    type: "string",
    defaultValue: "Label",
  },
  {
    name: "value",
    type: "string",
    localized: false,
    defaultValue: "Value",
  },
  {
    name: "disabled",
    type: "boolean",
    localized: false,
    defaultValue: false,
  },
];

export const phoneInputBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Phone input",
  description:
    "The phone input works as a simple text input or a complex input with dialling code options as dropdowns. The following state variables are expected to be provided: [name]PhoneNumber for handling the input value, [name]DiallingCode for handling the dropdown value.",
  canHaveChildren: false,
  noWrap: true,
  defaultStyles: {
    width: "100%",
    flexShrink: "1",
    outline: "none",
  },
  shouldReceiveBuilderProps: {
    builderContext: true,
  },
  inputs: [
    {
      name: "diallingCodes",
      type: "list",
      subFields: DiallingCodeFields,
      defaultValue: [],
    },
    {
      name: "defaultDiallingCode",
      type: "object",
      subFields: DiallingCodeFields,
      required: true,
      defaultValue: {
        label: "label",
        value: "value",
      },
      showIf: (options) => Number(options.get("diallingCodes")?.length) > 0,
    },
    {
      name: "onPhoneNumberInvalid",
      type: "javascript",
      localized: false,
    },
    {
      name: "onPhoneNumberBlur",
      type: "javascript",
      localized: false,
    },
    {
      name: "phoneNumberValue",
      type: "string",
      localized: false,
    },
    {
      name: "diallingCodeValue",
      type: "object",
      subFields: DiallingCodeFields,
      localized: false,
    },
    {
      name: "onPhoneNumberChange",
      type: "javascript",
      localized: false,
    },
    {
      name: "onDiallingCodeChange",
      type: "javascript",
      localized: false,
    },
    {
      name: "onChangeState",
      type: "javascript",
      localized: false,
    },
    {
      name: "onInitialize",
      type: "javascript",
      localized: false,
    },
    ...(generalFormConfig ?? []),
    ...(textualFormConfig ?? []),
  ],
};
